// Composite zone capability status (story #497): a zone criterion's own signal wiring AND the
// serving equipment's evaluated behaviour, joined into one honest indicator — replacing the flat
// status badge that only ever knew about the zone's own wiring. Shared by CapabilityList
// (/configuration) and KBBehaviorList's ZoneKBBehaviorList (zone detail panel), the two views that
// render live zone criteria. Derivation lives in the testable `zoneCapabilityBadgeView`.
import { cardToneDot, cardTonePill } from "@/lib/card-styles";
import { cn } from "@/lib/utils";
import type { ZoneCapability } from "@/lib/api/agent";
import { zoneCapabilityBadgeView } from "./zone-capability-badge";

export function ZoneCapabilityBadge({
  capability,
}: {
  capability: ZoneCapability;
}) {
  const view = zoneCapabilityBadgeView(capability);

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          cardToneDot[view.zoneSignal.tone],
        )}
        title={view.zoneSignal.title}
      />
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          cardToneDot[view.equipmentBehavior.tone],
        )}
        title={view.equipmentBehavior.title}
      />
      <span
        className={cn(
          "rounded-full border px-2 py-0.5 text-[11px] font-medium",
          cardTonePill[view.combined.tone],
        )}
        title={view.combined.title}
      >
        {view.combined.label}
      </span>
    </span>
  );
}
